module.exports = __webpack_public_path__ + "img/Loyalty gift box Icon - charcoal.fac330f6.svg";